module.exports = __webpack_public_path__ + "img/feedback.2e69fcfe.svg";